import { Link, useLocation } from 'react-router-dom'
import './StickyCTA.css'

const PHONE_HREF = 'tel:+15416589374'
const PHONE_NUMBER = '(541) 658-9374'

function StickyCTA() {
  const location = useLocation()
  const isGCPage = location.pathname === '/general-contractors'
  const isCountertopsPage = location.pathname === '/countertops'

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  const scrollToQuoteForm = (e: React.MouseEvent) => {
    e.preventDefault()
    document.getElementById('quote-form')?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  return (
    <div className="sticky-cta">
      {isGCPage ? (
        <div className="sticky-cta-buttons">
          <Link to="/booking" className="sticky-cta-button" onClick={scrollToTop}>
            Book Consultation
          </Link>
          <a href={PHONE_HREF} className="sticky-cta-button sticky-cta-phone">
            Call {PHONE_NUMBER}
          </a>
        </div>
      ) : isCountertopsPage ? (
        <a href="#quote-form" className="sticky-cta-button" onClick={scrollToQuoteForm}>
          Get a Quote
        </a>
      ) : (
        <Link to="/booking" className="sticky-cta-button" onClick={scrollToTop}>
          Schedule Free Consultation
        </Link>
      )}
    </div>
  )
}

export default StickyCTA
